import React from 'react';
import { connect } from 'react-redux';

import { NormalizedStore } from '@store/entity/entity.types';
import { entitySelectors } from '@store/entity/selectors';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

import { RatesV2 } from './RatesV2';
import { RatesV2DispatchProps, RatesV2OwnProps, RatesV2StoreProps } from './RatesV2.types';

const mapStateToProps = (state: NormalizedStore): RatesV2StoreProps => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  property: entitySelectors.getProperty(state),
});

const mapDispatchToProps = (dispatch): RatesV2DispatchProps => ({
  changeJourneyParam: (param, value) => changeJourneyParam(param, value)(dispatch),
});

export const RatesV2Connected: React.ComponentType<RatesV2OwnProps> = connect(
  mapStateToProps,
  mapDispatchToProps
)(RatesV2);
